








import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import { WithAppContext } from '@/mixins';

import DesktopCartView from '@/components/cart/DesktopCartView.vue';
import MobileCartView from '@/components/cart/MobileCartView.vue';

@Component({
  components: {
    DesktopCartView,
    MobileCartView,
  },
})
export default class Cart extends mixins(WithAppContext) { }

